import * as React from "react";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import PrwcOutlinedButton from "../../../../../../../ui/widgets/custom/buttons/PrwcOutlinedButton";
import PrwcFileUpload from "../../../../../../../ui/widgets/custom/PrwcFileUpload";
import PrwcTimeline from "../../../../../../../ui/widgets/custom/PrwcTimeline";
import "./BulkUsers.scss";

const BulkUsers = (props: any) => {
  const { t } = useTranslation();
  const hiddenFileInput: any = useRef(null);
  const {data, onUpload } = props;


  const handleDownloadUserInfoInCSVFile = () => {};

  const handleDownloadBlankCSVTemplate = () => {};

  const attachCSVFile = () => {
    if (hiddenFileInput && hiddenFileInput.current) {
      hiddenFileInput.current.click();
    }
  };

  const handleFileUpload = (file: any) => {
    onUpload(file);
  }

  const downloadCSVFile = () => {
    return (
      <div>
        <div className="font-semibold">{t("users.label.downloadCSVFile")}</div>
        <div className="flex flex-col my-4 md:flex-row ">
          <div className="mr-4 ">
            <PrwcOutlinedButton
              icon="pi pi-download"
              className="p-button-outlined p-button-sm"
              labelKey={t("users.action.downloadUserInfoInCSVFile")}
              onClick={handleDownloadUserInfoInCSVFile}
            ></PrwcOutlinedButton>
          </div>
          <div className="mt-2 md:mt-0">
            <PrwcOutlinedButton
              icon="pi pi-download"
              className="p-button-outlined p-button-sm"
              labelKey={t("users.action.downloadBlankCSVTemplate")}
              onClick={handleDownloadBlankCSVTemplate}
            ></PrwcOutlinedButton>
          </div>
        </div>
      </div>
    );
  };

  const addOrEditUserInfo = () => {
    return (
      <div className="add-or-edit-user-info">
        <div className="font-semibold">
          {t("users.label.addOrEditUserInfo")}
        </div>
        <div className="text-sm text-gray-400">
          {t("users.label.userInforequiredFields")}
        </div>
        <div className="my-4">
          <table>
            <tbody>
            <tr className="column-heading">
              <td>A</td>
              <td>B</td>
              <td>C</td>
              <td>D</td>
              <td>E</td>
            </tr>
            <tr className="column-name">
              <td>First name</td>
              <td>Last name</td>
              <td>Email address</td>
              <td>Password</td>
              <td>Organization</td>
            </tr>
            <tr>
              <td>John</td>
              <td>Doe</td>
              <td>johndoe@example.com</td>
              <td>523fhs</td>
              <td>/Sales</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  const uploadCSVFile = () => {
    return (
      <div>
        <div className="font-semibold">{t("users.label.uploadCSVFile")}</div>
        <div className="my-4">
          <div>
      
            <PrwcOutlinedButton
              className="p-button-outlined p-button-sm"
              labelKey={t("users.action.attachCSVFile")}
              onClick={attachCSVFile}
            ></PrwcOutlinedButton>
            <PrwcFileUpload ref={hiddenFileInput} data={data} onUpload={(file: any) => handleFileUpload(file)}></PrwcFileUpload>
          </div>
        </div>
      </div>
    );
  };

  const customizedMarker = (item: any) => {
    return (
      <span className="flex items-center justify-center w-6 h-6 text-white bg-blue-700 rounded-full">
        {item.index}
      </span>
    );
  };

  const customizedContent = (item: any) => {
    return <div>{item.section()}</div>;
  };

  const sections = [
    {
      index: 1,
      section: downloadCSVFile,
    },
    {
      index: 2,
      section: addOrEditUserInfo,
    },
    {
      index: 3,
      section: uploadCSVFile,
    },
  ];

  return (
    <div>
      <PrwcTimeline
        events={sections}
        marker={customizedMarker}
        content={customizedContent}
      ></PrwcTimeline>
    </div>
  );
};

export default BulkUsers;
